<mojo-side-nav
  [backdropEnabled]="true"
  [drawerEnlarged]="true"
  [opened]="opened"
  (closed)="close()"
>
  <ng-container header-actions>
    <button
      *ngIf="isPreviousButtonDisabled; else previousButton"
      mat-icon-button
      [disabled]="true"
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <ng-template #previousButton>
      <mat-icon
        class="drawer-action-button"
        (click)="changeCandidateFn(-1)"
      >keyboard_arrow_left</mat-icon>
    </ng-template>
    <button
      *ngIf="isNextButtonDisabled; else nextButton"
      mat-icon-button
      [disabled]="true"
    >
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <ng-template #nextButton>
      <mat-icon
        class="drawer-action-button"
        (click)="changeCandidateFn(1)"
      >keyboard_arrow_right</mat-icon>
    </ng-template>
  </ng-container>
  <mojo-candidate-card
    [candidate]="sideDrawerCandidate"
    [displayCandidateCardArea]="false"
    [hideResumeDownloadButton]="true"
  >
    <aside>
      <a
        target="_blank"
        matTooltip="Open resume in full screen"
        [matTooltipPosition]="'above'"
        [href]="pdfViewerAdapterService.pdfUrl"
        class="profile-icon d-flex justify-content-center align-items-center full-screen-link"
      >
        <mat-icon class="icons">
          open_in_full
        </mat-icon>
      </a>
    </aside>
    <aside>
      <div
        matTooltip="See full profile"
        [matTooltipDisabled]="(isMobileViewService.isMobileView$() | async)"
        class="profile-icon d-flex justify-content-center align-items-center"
        [routerLink]="['/candidates', sideDrawerCandidate?.id, 'details']"
      >
        <mat-icon class="icons">
          open_in_new
        </mat-icon>
      </div>
    </aside>
    <aside>
      <mojo-dropdown-menu-with-icons
        *ngIf="jobId === undefined; else inJobContextView"
        [targetId]="sideDrawerCandidate.id"
        [menuItems]="commonMenuItems"
      ></mojo-dropdown-menu-with-icons>
      <ng-template #inJobContextView>
        <mojo-dropdown-menu-with-reject
          [candidateId]="sideDrawerCandidate.id"
          [jobId]="jobId"
          [upperMenu]="jobMenuItems"
          [lowerMenu]="commonMenuItemsInsideJob"
        ></mojo-dropdown-menu-with-reject>
      </ng-template>
    </aside>
  </mojo-candidate-card>
  <mat-tab-group
    *ngIf="opened"
    class="tabs clear-background mt-3"
  >
    <mat-tab label="RESUME">
      <ng-template matTabContent>
        <mojo-candidate-details-container
          [hideDetails]="true"
          [resumeTitleHidden]="true"
          [showCard]="false"
          [isNotAnonymized]="sideDrawerCandidate.isNotAnonymized"
          [fromTalentPool]="true"
          [isFullScreenEnable]="false"
        >
        </mojo-candidate-details-container>
      </ng-template>
    </mat-tab>
    <ng-container *mojoHasFeatureExtension="tasksExtension">
      <mat-tab
        *mojoHasPrivilege="tasksPrivilege"
        label="TASKS"
      >
        <ng-template matTabContent>
          <mojo-tasks-container
            [entityType]="tasksEntityType"
            [entityId]="sideDrawerCandidate.id"
            [sideDrawerConfiguration]="true"
            [showLine]="false"
            [width]="(isMobileViewService.isMobileView$() | async) ? '' : '53%'"
            [fromTalentPool]="fromTalentPool"
          >
          </mojo-tasks-container>
        </ng-template>
      </mat-tab>
    </ng-container>
    <mat-tab
      *mojoHasPrivilege="privileges.candidates.notes"
      label="NOTES"
    >
      <ng-template matTabContent>
        <mojo-notes-container
          [setDefaultNotesPageFilter]="true"
          [subject]="subject"
          [secondarySubject]="noteSubject.Candidate"
          [pagination]="false"
          [isWidgetView]="false"
          [subjectId]="sideDrawerCandidate.id"
          [sideDrawerConfiguration]="true"
          [closeNotes]="closeNotes$"
        >
        </mojo-notes-container>
      </ng-template>
    </mat-tab>
    <mat-tab
      *ngIf="shouldDisplayFiles$ | async"
      label="FILES"
    >
      <ng-template matTabContent>
        <mojo-candidates-attachments-container [sideDrawerConfiguration]="true">
        </mojo-candidates-attachments-container>
      </ng-template>
    </mat-tab>
    <ng-container *mojoHasFeatureExtension="talentPoolExtension">
      <mat-tab
        *mojoHasPrivilege="talentPoolsPrivilege"
        label="POOLS"
      >
        <ng-template matTabContent>
          <mojo-candidate-talent-pools [candidate]="sideDrawerCandidate">
          </mojo-candidate-talent-pools>
        </ng-template>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
</mojo-side-nav>
